import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
import { Typography } from '@mui/material';
import Container from 'components/Container';
import Box from '@mui/material/Box';
import Archive_2022 from '../CurricularClass52023/Archive_2022';
import CoScholacticSidebar2026 from '../CoScholacticSidebar2026/CoScholacticSidebar2026';

const VisitGKVK2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });



  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  
 
const p1 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Visit-GKVK/1.webp`;
const p2 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Visit-GKVK/2.webp`;
const p3 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Visit-GKVK/3.webp`;
const p4 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Visit-GKVK/4.webp`;
const p5 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Visit-GKVK/5.webp`;
const p6 = `${config.base_image_url_2026}/home/events-activities/association/Co-Scholastic/Visit-GKVK/6.webp`;

  const photos = [
    
{
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
}

  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      {/* <Typography variant='h4' align='center'>
      VENUE- Rangoli Metro Art Centre, MG road.
        </Typography> */}
        <Typography
        fontSize = "x-small"
        ><br/><br/>
    Class: 9	  DATE: 3 October 2026   

        </Typography>
        

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
As part of the Vocational Education programme, the students of Grade 9 undertook an educational visit to<strong>Gandhi Krishi Vignana Kendra (GKVK), Bengaluru, on 3rd October 2026.</strong> The visit was organised to provide students
 with practical exposure to agriculture, horticulture and related vocational fields.
<br></br>
During the visit, students explored the <strong>ATIC (Agricultural Technology Information Centre Nursery)</strong>, where students gained knowledge about different varieties of plants, seedlings, nursery practices and plant care. Students also visited the Agricultural Science Museum, which provided valuable insights into agricultural development, traditional farming practices, agricultural tools and modern technologies used in the field of agriculture. The visit enabled students to connect the classroom learning with practical experiences and helped students understand the importance of sustainable agriculture and scientific farming methods. It also created awareness about the diverse career and vocational opportunities available in the agricultural sector.
     <br></br>
The educational visit was an enriching and memorable experience that enhanced students’ knowledge, curiosity, appreciation of agriculture and its vital role in our society. The visit helped them understand the hard work of farmers and introduced them to various vocational opportunities in agriculture and related fields. 
It was an informative and enjoyable trip that took learning beyond the classroom.   
  <br></br>

        </Typography>
      </Box>
      {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
"Local arts are the living diary of a community, capturing its unique spirit, struggles, and triumphs in a language that transcends words."<br/>
        </Typography> */}

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 350 : 550}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <CoScholacticSidebar2026 />
             </Box>
             <Box marginBottom={4}>
               <Archive_2022/>
             </Box>
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default VisitGKVK2026;